module.exports = __webpack_public_path__ + "img/2+.e7f2e125.png";